import React, {useEffect, useState} from "react";
import bgImage from "../../../assets/images/bg-sign-up-cover.jpeg";
import CoverLayout from "../components/CoverLayout";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button, FormControl, FormHelperText, InputAdornment, Popover, Fade, Icon, Tooltip, ClickAwayListener } from "@mui/material";
import MDInput from "../../../components/MDInput";
import IconButton from "@mui/material/IconButton";
import { Visibility, VisibilityOff, Help, FormatListBulleted, Search, Info } from "@mui/icons-material";
import MDButton from "../../../components/MDButton";
import {useDispatch, useSelector} from "react-redux";
import YupPassword from 'yup-password';
import {
    authRegister,
    getEmailCode,
    getEmailCodeVerify,
    getVerificationCode,
    onErrorAlert,
    onSuccessAlert
} from "../../../actions";
import {noop} from "lodash";
import {Link, useNavigate} from "react-router-dom";
import FramerFade from "../../../components/Animation/Fade";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {useTranslation} from "react-i18next";

YupPassword(yup);
export default function LegacySignUp() {

    const style = {
        img: {
            width: '120px',
            height: '40px',
            position: 'absolute',
            right: 0,
            top: -10,
            border: '2px solid grey',
            cursor: 'pointer'
        }
    }
    const [img, setImg] = useState('');

    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
    const [showHelp, setShowHelp] = useState(false);
    const darkMode = useSelector(state => state?.common?.darkMode)
    const verification = useSelector(state => state?.auth?.verification)
    const dispatch = useDispatch()
    const [uuid, setUuid] = useState('');
    const nav = useNavigate()
    const [activeStep, setActiveStep] = useState(0);
    
    const [code, setCode] = useState(Array(6).fill(''));
    
    const [seconds, setSeconds] = useState(0);
    const [show, setShow] = useState(true);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isOpenHelp, setIsOpenHelp] = React.useState(false);
    const [isOpenInfo, setIsOpenInfo] = React.useState(false);
    const { t, i18n } = useTranslation();


    useEffect(() => {
        const intervalId = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
        }, 1000);
        if (seconds === 0) {
            setShow(false);
        } else {
            setShow(true)
        }

        return () => clearInterval(intervalId);
    }, [seconds]);
    useEffect(() => {
        if(activeStep === 0){
            // reset()
            clearErrors()
        }

        if(activeStep === 1){
            setCode(Array(6).fill(''));
            setSeconds(99); // 重置秒数
        } else {

            setSeconds(0);

        }

        if(activeStep === 5) {
            const apiGet = async () => {
                await dispatch(getVerificationCode(noop,onError))
            }
            apiGet().then()
        }

    }, [activeStep])
    
    const handleChange = (e, index) => {
        const value = e.target.value;
        if (value.length <= 1) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            if (value && index < 5) {
                document.getElementById(`code-${index + 1}`).focus();
            }
        }
    };

    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData('text').slice(0, 6);
        const newCode = pasteData.split('');
        while (newCode.length < 6) {
            newCode.push('');
        }
        setCode(newCode);
        
        const lastFilledIndex = newCode.findIndex((char, i) => char === '' || i === newCode.length - 1);
        document.getElementById(`code-${lastFilledIndex}`).focus();
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !code[index]) {
            document.getElementById(`code-${index - 1}`).focus();
        } else if (e.key === "Enter") {
            submitCode();
        }
    };

    const handleVerifyEmail = async () => {
        if (!errors.email && getValues('email')!=='') {
            const email = getValues('email')
            await dispatch(getEmailCode(email,onEmailSuccess,onError))
            // onEmailSuccess()
        }
    }
    
    const onEmailSuccess = () => {
        setActiveStep(1)
    }
    const handleResendVerifyEmail = async () => {
        if (!errors.email && getValues('email')!=='' ) {
            const email = getValues('email')
            await dispatch(getEmailCode(email,onEmailResendSuccess,onError))
        }
    }

    const handleVerifyEmailCode = async () => {
        submitCode();
    }
    
    const submitCode = async () => {
        const formData = {};
        const verificationCode = code.join('');
        if(verificationCode!==''){
            formData.emailAddress = getValues('email')
            formData.emailCode = verificationCode
            await dispatch(getEmailCodeVerify(formData,onEmailCodeSuccess,onError))
        }
    };
    
    function onEmailCodeSuccess() {
        setActiveStep(2)
    }
    const onEmailResendSuccess =() => {
        dispatch(onSuccessAlert(t('resend verification code successfully')))
        setSeconds(99);
    }

    const schema = yup
        .object({
            email: yup.string().trim().email().required(t('ForgotPasswordPage.Email is Required')),
            owner: yup.string().min(4, t('ForgotPasswordPage.Owner ID must contain 4 or more characters')).required(t("Required")),
            user: yup.string().min(3, t('ForgotPasswordPage.User ID must contain 3 or more characters')).required(t("Required")),
            password: yup.string().min(
                6,
                t('ForgotPasswordPage.Password must contain 6 or more characters')
            ).minLowercase(1, t('ForgotPasswordPage.Password must contain at least 1 lower case letter'))
                .minUppercase(1, t('ForgotPasswordPage.Password must contain at least 1 upper case letter'))
                .minNumbers(1, t('ForgotPasswordPage.Password must contain at least 1 number'))
                .required(t("Required")),
            confirmpassword: yup
                .string()
                .oneOf([yup.ref("password"), null], t('ForgotPasswordPage.Passwords must match'))
                .required(t("Required")),
        })

    const {register, setError, handleSubmit, getValues, setValue, clearErrors, formState: {errors}} = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    useEffect(() => {
        const apiGet = async () => {
            await dispatch(getVerificationCode(noop, onError))
        }
        apiGet().then()
    }, []);

    useEffect(() => {
        if (verification) {
            setImg(`data:image/gif;base64,${verification?.img}`)
            setUuid(verification.uuid)
        }
    }, [verification]);

    const onSubmit = async (data) => {

        const formData = {}
        formData.username = data.user
        formData.code = data.code
        formData.password = data.password
        formData.uuid = uuid
        formData.userInfo = {}
        formData.userInfo.email = data?.email.trim()
        formData.userInfo.oldUserFlag = "Y"
        formData.userInfo.omsOwnerId = data.owner
        formData.userInfo.code = data.code
        formData.userInfo.uuid = uuid
        formData.userInfo.username = data.user
        formData.userInfo.password = data.password
        formData.userInfo.confirmPassword = data.confirmpassword
        await dispatch(authRegister(formData, onRegisterSuccess, onError))

    }

    const onRegisterSuccess = (msg) => {

        dispatch(onSuccessAlert(t(msg)))
        nav('/authentication/sign-in')

    }

    const onError = async (msg, username) => {
        await dispatch(getVerificationCode())

        if (username) {
            setUsernameList([...usernameList, username])
            setActiveStep(2)
            setError('username', {type: 'errorName', message: t(`${t('SignUpPage.Username')} ${username} ${t('SignUpPage.already exists')}`)})
            dispatch(onErrorAlert(t(`${t('SignUpPage.Username')} ${username} ${t('SignUpPage.already exists')}`)))
        } else {
            dispatch(onErrorAlert(t(msg)))
        }
    }
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleClickShowPasswordConfirmation = () => setShowPasswordConfirmation((show) => !show);
    
    const handleClickShowHelp = (event) => {
        setAnchorEl(event.currentTarget);
        setIsOpenHelp(!isOpenHelp);
    }


    return (
    <React.Fragment>
    <CoverLayout image={bgImage} >
        <Card>
            <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="success"
                mx={2}
                mt={-3}
                p={3}
                mb={1}
                textAlign="center"
            >
                <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                    {t('LegacySignUpPage.Legacy User Register')}
                </MDTypography>
                <MDTypography display="block" variant="button" color="white" my={1}>
                    {t('LegacySignUpPage.Enter your information to synchronization with the current system')}
                </MDTypography>
            </MDBox>
                    <MDBox pt={4} pb={2} px={3}>
                        <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                            <FramerFade isActive={activeStep === 0} delay={0}>
                                <MDBox mb={2}>
                                    <FormControl
                                        error={!!errors.email}
                                        fullWidth
                                        required
                                        focused={true}
                                    >
                                        <MDInput
                                            type="email"
                                            label={t('LegacySignUpPage.Email')}
                                            variant="standard"
                                            fullWidth
                                            required
                                            {...register("email")}
                                            error={!!errors?.email}
                                        />
                                        <FormHelperText
                                            sx={{fontWeight: 'medium'}}>{errors?.email?.message}</FormHelperText>
                                    </FormControl>

                                </MDBox>
                                <MDBox mt={2}>
                                    <MDButton variant="gradient" color="info" fullWidth onClick={handleVerifyEmail}>
                                        {t('Continue')}
                                    </MDButton>
                                </MDBox>
                            </FramerFade>
                            <FramerFade isActive={activeStep === 1} delay={0}>
                                <Grid textAlign='center'><Icon style={darkMode ? {color: 'white'} : {color: 'text'}}
                                                               fontSize={'large'}>lock</Icon></Grid>
                                <Typography variant={'h5'} align="center">{t('ForgotPasswordPage.Enter your verification Code')}</Typography>
                                <MDTypography align="center" display="block" variant="button" my={1}>
                                    {`${t('ForgotPasswordPage.We sent a verification code to')} ${getValues('email')}`}
                                </MDTypography>
                                
                                <MDBox component="form" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                    <MDBox sx={{ display: 'flex', gap: 1 }} onPaste={handlePaste}>
                                        {code.map((digit, index) => (
                                            <TextField
                                                key={index}
                                                id={`code-${index}`}
                                                value={digit}
                                                onChange={(e) => handleChange(e, index)}
                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                InputProps={{ maxLength: 1, style: { textAlign: 'center' } }}
                                                autoFocus={index === 0}
                                                sx={{
                                                    width: '40px', height: '20px', '& .MuiOutlinedInput-input': {
                                                        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                            '-webkit-appearance': 'none',
                                                        }
                                                    }
                                                }}
                                            />
                                        ))}
                                    </MDBox>
                                </MDBox>
                                
                                <MDBox mt={4} display="flex" alignItems="center" justifyContent="start">
                                    <MDTypography display="block" variant="button">
                                        {t(`ForgotPasswordPage.Haven't receive a code?`)}
                                    </MDTypography>
                                    <Button sx={{padding: 1}} onClick={handleResendVerifyEmail}
                                            disabled={show}>{t('Resend')}</Button>
                                    <MDTypography display="block" variant="button">
                                        {show && `${seconds}s`}
                                    </MDTypography>
                                </MDBox>

                                <MDBox mt={2}>
                                    <MDButton variant="gradient" color="info" fullWidth onClick={handleVerifyEmailCode}>
                                        Verify
                                    </MDButton>
                                </MDBox>

                            </FramerFade>
                            <FramerFade isActive={activeStep === 2} delay={0}>
                                <MDBox>
                                    <FormControl
                                        error={!!errors.owner}
                                        fullWidth
                                        required
                                        focused={true}
                                    >
                                        <MDInput
                                            type="text"
                                            label={t('ForgotPasswordPage.Legacy Owner ID')}
                                            variant="standard"
                                            fullWidth
                                            required
                                            {...register("owner")}
                                            InputProps={{
                                                endAdornment:
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="Owner ID Help"
                                                            onClick={handleClickShowHelp}
                                                            edge="end"
                                                        >
                                                            <Help color={darkMode?'white':'info.main'} />
                                                        </IconButton>
                                                    </InputAdornment>

                                            }}
                                            // error={!!errors?.owner}
                                        />
                                        <FormHelperText sx={{fontWeight:'medium'}}>{errors?.owner?.message}</FormHelperText>
                                    </FormControl>
                                </MDBox>
                                <MDBox >
                                    <FormControl
                                      error = {!!errors.user}
                                      fullWidth
                                      required
                                      focused = {true}
                                    >
                                        <MDInput
                                            type="text"
                                            label={t('ForgotPasswordPage.Legacy Username')}
                                            variant="standard"
                                            fullWidth
                                            required
                                            {...register("user")}
                                            // error={!!errors?.user}
                                            InputProps={{
                                                endAdornment:
                                                    <InputAdornment position="end">
                                                        <ClickAwayListener onClickAway={() => setIsOpenInfo(false)} >
                                                            <Tooltip
                                                                title={t('ForgotPasswordPage.Known as User ID on the old OCP platform')}
                                                                open={isOpenInfo}
                                                                onClickAway
                                                            >
                                                                <IconButton
                                                                    aria-label="Legacy Username Info"
                                                                    edge="end"
                                                                    onClick={() => setIsOpenInfo(!isOpenInfo)}
                                                                >
                                                                    <Info color={darkMode?'white':'info.main'} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </ClickAwayListener>
                                                    </InputAdornment>

                                            }}
                                        />
                                        <FormHelperText sx={{fontWeight:'medium'}}>{errors?.user?.message}</FormHelperText>
                                    </FormControl>
                                </MDBox>
                                <MDBox mb={1}>
                                    <FormControl
                                        error = {!!errors.password}
                                        fullWidth
                                        required
                                        focused = {true}
                                    >
                                        <MDInput
                                            type={showPassword ? 'text' : 'password'}
                                            label={t('ForgotPasswordPage.New Password')}
                                            variant="standard"
                                            fullWidth
                                            required
                                            {...register("password")}
                                            InputProps={{
                                                endAdornment:
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                            edge="end"
                                                        >
                                                            {showPassword ? <VisibilityOff
                                                                    color={darkMode ? 'white' : 'info.main'}/> :
                                                                <Visibility color={darkMode ? 'white' : 'info.main'}/>}
                                                        </IconButton>
                                                    </InputAdornment>

                                            }}
                                        />
                                        <FormHelperText sx={{fontWeight:'medium'}}>{errors?.password?.message}</FormHelperText>
                                        <MDTypography variant={'caption'} mt={1} >{t('ForgotPasswordPage.Password must have')}</MDTypography>
                                        <MDTypography variant={'caption'} pl={1} >{t('ForgotPasswordPage.at least 6 characters')}</MDTypography>
                                        <MDTypography variant={'caption'} pl={1} >{t('ForgotPasswordPage.at least one uppercase')} </MDTypography>
                                        <MDTypography variant={'caption'} pl={1} >{t('ForgotPasswordPage.at least one lowercase')} </MDTypography>
                                        <MDTypography variant={'caption'} pl={1} >{t('ForgotPasswordPage.at least one number')} </MDTypography>
                                    </FormControl>
                                </MDBox>
                                <MDBox mb={2}>
                                    <FormControl
                                        error={!!errors.confirmpassword}
                                        fullWidth
                                        required
                                        focused={true}
                                    >
                                        <MDInput
                                            type={showPasswordConfirmation ? 'text' : 'password'}
                                            label={t("ForgotPasswordPage.New Password Confirmation")}
                                            variant="standard"
                                            fullWidth
                                            required
                                            {...register("confirmpassword")}
                                            InputProps={{
                                                endAdornment:
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPasswordConfirmation}
                                                            edge="end"
                                                        >
                                                            {showPasswordConfirmation ? <VisibilityOff
                                                                    color={darkMode ? 'white' : 'info.main'}/> :
                                                                <Visibility color={darkMode ? 'white' : 'info.main'}/>}
                                                        </IconButton>
                                                    </InputAdornment>

                                            }}
                                        />
                                        <FormHelperText
                                            sx={{fontWeight: 'medium'}}>{errors?.confirmpassword?.message}</FormHelperText>
                                    </FormControl>
                                </MDBox>
                                <MDBox sx={{position: 'relative'}}>
                                    <FormControl
                                        error={!!errors.code}
                                        fullWidth
                                        required
                                    >
                                        <MDInput
                                            label={t('SignInPage.Verification')}
                                            {...register("code")}
                                            variant='standard'
                                            fullWidth
                                            required
                                            error={!!errors.code}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">
                                                    <img
                                                        src={img}
                                                        alt={'verification code'}
                                                        style={style.img}
                                                        onClick={async () => await dispatch(getVerificationCode())}
                                                        loading="lazy"
                                                    />
                                                </InputAdornment>
                                            }}
                                        />
                                        <FormHelperText
                                            sx={{fontWeight: 'medium'}}>{errors?.code?.message}</FormHelperText>
                                    </FormControl>
                                </MDBox>
                                <MDBox mt={2}>
                                    <MDButton type='submit' variant="gradient" color="info" fullWidth>
                                        {t('Submit')}
                                    </MDButton>
                                </MDBox>
                            </FramerFade>
                        </MDBox>
                        <MDBox mt={2} mb={1} textAlign="center">
                            <MDTypography variant="button" color="text">
                                {t('LegacySignUpPage.Already have an account')+"? "}
                                <MDTypography
                                    component={Link}
                                    to="/authentication/sign-in"
                                    variant="button"
                                    color="info"
                                    fontWeight="medium"
                                    textGradient
                                >
                                    {t('SignInPage.Sign In')}
                                </MDTypography>
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                </Card>
            </CoverLayout>
        <Popover
            open={isOpenHelp}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            disableScrollLock={true}
            onClose={() => setIsOpenHelp(false)}
            PaperProps={{
                sx: {
                    minWidth: 250,
                    maxWidth: 380,
                    width: '100%',
                },
            }}
        >
            <MDTypography variant="h6" color="info" px={2} py={1} mb={-1}>
                {t('ForgotPasswordPage.How to Find Your Owner ID')}
            </MDTypography>

            <MDBox mx={2} px={1} mb={-1}>
                <MDTypography
                    variant="caption"
                >
                    {t("ForgotPasswordPage.1. Visit the ")}
                </MDTypography>

                <MDTypography
                    component={Link}
                    to="https://oms.darwynnfulfillment.com/ocplogin"
                    variant="caption"
                    color="info"
                    fontWeight="medium"
                    textGradient
                    target="_blank"
                >
                    {t("ForgotPasswordPage.old OCP platform")}
                </MDTypography>
            </MDBox>

            <MDTypography
                variant="caption"
                mx={2}
                px={1}
            >
                {t("ForgotPasswordPage.2. Log in with your old credentials")}
            </MDTypography>

            <MDTypography
                display="block"
                variant="caption"
                mx={2}
                px={1}
            >
                {t("ForgotPasswordPage.3. Open ")}
                <FormatListBulleted color={darkMode?'white':'info.main'} />
                {t("ForgotPasswordPage. SIDEBAR and go to")}
            </MDTypography>

            <MDTypography
                display="block"
                variant="caption"
                mx={2}
                px={1}
                mb={1}
            >
                Data Center > Commodity Setup > Commodity Entry
            </MDTypography>

            <MDTypography
                display="block"
                variant="caption"
                mx={2}
                px={1}
            >
                {t("ForgotPasswordPage.4. Press ")}
                <Search color={darkMode?'white':'info.main'} />
                {t("ForgotPasswordPage. QUERY to locate items.")}
            </MDTypography>

            <MDTypography
                display="block"
                variant="caption"
                mx={2}
                mb={2}
                px={1}
            >
                {t("ForgotPasswordPage.Your Owner ID is in the first column (eg. S1234)")}
            </MDTypography>

            <MDBox mx={3} mb={1} >
                <MDButton
                    variant="gradient"
                    coloredShadow="success"
                    text="standard"
                    color="info"

                    onClick={() => setIsOpenHelp(false)}
                >
                    {t("ForgotPasswordPage.Got it!")}
                </MDButton>
            </MDBox>
        </Popover>
        </React.Fragment>)
}